import { useEffect, useState } from "react";

import { RESEND_COOLDOWN_SECONDS, secondsUntilResend } from "./cooldown";

/** The countdown before another send is allowed. `lastSent` is the send the
 * screen opened on, so the countdown carries on across a reload; read once,
 * when the screen mounts. `restart` begins a new window and counts the send. */
export function useResendCooldown(
  lastSent: { sentAt: number; count: number } | undefined,
) {
  const [readyAt, setReadyAt] = useState(
    () => (lastSent?.sentAt ?? Date.now()) + RESEND_COOLDOWN_SECONDS * 1000,
  );
  const [now, setNow] = useState(() => Date.now());
  const [sendCount, setSendCount] = useState(lastSent?.count ?? 1);
  const secondsLeft = secondsUntilResend(readyAt, now);

  useEffect(() => {
    if (secondsLeft === 0) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [secondsLeft]);

  const restart = () => {
    const current = Date.now();
    setNow(current);
    setReadyAt(current + RESEND_COOLDOWN_SECONDS * 1000);
    setSendCount((count) => count + 1);
  };

  return { secondsLeft, sendCount, restart };
}
